import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsStandUpPaddlingNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M27 22v-3h10v3zM27 25v3h10v-3zM29 34v-3h6v3z" />
        <path d="M31.494.087c.33-.11.683-.11 1.012 0 .5.169 2.91 1.12 5.183 4.36C39.959 7.682 42 13.071 42 21.954c0 15.431-6.06 24.557-6.614 25.36a1.589 1.589 0 01-1.312.686h-4.147c-.421 0-.96-.175-1.313-.686C28.06 46.511 22 37.385 22 21.954c0-8.883 2.042-14.272 4.311-17.507 2.272-3.24 4.682-4.191 5.183-4.36zM32 3.135c-.658.346-1.944 1.197-3.233 3.035C26.932 8.787 25 13.532 25 21.954 25 34.652 29.329 42.761 30.692 45h2.616C34.67 42.76 39 34.652 39 21.954c0-8.422-1.932-13.167-3.767-15.784C33.944 4.332 32.658 3.48 32 3.135zM6.149 42.56c1.769.645 3.329.39 4.365.03 1.344-.467 2.065-1.617 2.414-2.575l.905-2.487a11.5 11.5 0 00-.383-8.794l-.385-.825 8.223-22.592 1.88.684 1.025-2.82L17.615.789 16.59 3.607l1.88.684-8.232 22.615-.794.37a11.5 11.5 0 00-5.946 6.49l-.905 2.487c-.35.958-.535 2.302.194 3.524a6.448 6.448 0 003.363 2.784zm3.38-2.804c-.576.2-1.402.332-2.354-.014a3.449 3.449 0 01-1.813-1.503c-.08-.134-.143-.435.049-.96l.905-2.488a8.5 8.5 0 014.395-4.796l.013-.006.007.013a8.5 8.5 0 01.283 6.5l-.905 2.487c-.191.525-.432.716-.58.767z" />
      </g>
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsStandUpPaddlingNormalLarge;
